import { Country } from "../../../../features/countries/types";
import { convertValueToLocalString } from "../../../../utils/convertValueToLocalString";

interface HoverTooltipProps {
    facilities_value: string;
    direct_jobs_value: string;
    indirect_jobs_value: string;
    gdp_contribution_value: string;
}

export function hoverTooltip(
  country: Country | HoverTooltipProps,
  name: string,
  showFacilities?: boolean
) {
  return `
    <div>   
      <h3>Data available for your related country</h3>
      <h3>${name}</h3>
      <ul>
        ${
          showFacilities
            ? `<li>
          ${convertValueToLocalString(country.facilities_value)} facilities
        </li>`
            : ""
        }
        <li>
          Direct jobs: ${convertValueToLocalString(country.direct_jobs_value)}
        </li>
        <li>
          Indirect jobs: ${convertValueToLocalString(
            country.indirect_jobs_value
          )}
        </li>
        <li>
          ${country.gdp_contribution_value} of GDP
        </li>
      </ul>
    </div>
  `;
}
